<div class="w-100 center-align-content2 text-center" style="height: 100%;">
<p class="oriya-color1 font-size4">Tarang is presently not available in your country.<br>We will be coming soon.</p>
</div>
